"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'branch.form.title.edit': 'Editar Rama',
    'branch.form.title.add': 'Agregar Rama',
    'branch.form.back': 'Atrás',
    'branch.form.name.label': 'Nombre',
    'branch.form.name.placeholder': 'Nombre de la rama',
    'branch.form.color.label': 'Color',
    'branch.form.color.placeholder': 'Color de la rama',
    'branch.form.description.label': 'Descripción',
    'branch.form.description.placeholder': 'Descripción',
    'branch.form.submit.update': 'Actualizar Rama',
    'branch.form.submit.create': 'Crear Rama',
};
